import { Component } from '@angular/core';
import { SpThemingService } from '../../../services/sp-theming/sp-theming.service';
import {ImageType} from '../sp-page-error/sp-page-error.component';
import {Router} from '@angular/router';

@Component({
  selector: 'app-sp-page-maintenance',
  templateUrl: './sp-page-maintenance.component.html'
})
export class SpPageMaintenanceComponent {
  protected readonly ImageType = ImageType;

  constructor(
    private _spTheming: SpThemingService,
    private router: Router
  ) {
    this._spTheming.setSpThemeName('dashboard-default');
  }

  async onButtonClick() {
    await this.router.navigate(['/']);
  }
}
